import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import Icon from '../ui/icon';
import { cn } from '../../lib/utils';

interface StatCardProps {
  title: string;
  value: string | number;
  icon: string;
  trend?: {
    value: number;
    isPositive: boolean;
  };
  badge?: string;
  className?: string;
  isLoading?: boolean;
  onClick?: () => void;
}

const StatCard: React.FC<StatCardProps> = ({
  title,
  value,
  icon,
  trend,
  badge,
  className,
  isLoading = false,
  onClick
}) => {
  return (
    <Card 
      className={cn(
        "hover:shadow-md transition-shadow", 
        onClick && "cursor-pointer hover:shadow-lg",
        className
      )}
      onClick={onClick}
    >
      <CardContent className="p-4">
        <div className="flex items-center justify-between">
          <div className="flex items-start gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10">
              <Icon name={icon} size={20} className="text-primary" />
            </div>
            <div className="flex flex-col">
              <div className="text-sm font-medium text-muted-foreground">{title}</div>
              <div className="flex items-center justify-start gap-1">
                {isLoading ? (
                  <div className="text-2xl font-bold text-foreground animate-pulse">
                    <div className="h-8 w-12 bg-muted rounded"></div>
                  </div>
                ) : (
                  <div className="text-2xl font-bold text-foreground">{value}</div>
                )}
                <div className="flex flex-col items-end">
                  {badge && !isLoading && (
                    <Badge variant="secondary" className="text-xs text-muted-foreground">
                      {badge}
                    </Badge>
                  )}
                  {trend && !isLoading && (
                    <div className={cn(
                      "flex items-center gap-1 text-xs font-medium",
                      trend.isPositive ? "text-green-600" : "text-red-600"
                    )}>
                      <Icon 
                        name={trend.isPositive ? "chevron-up" : "chevron-down"} 
                        size={12} 
                      />
                      {Math.abs(trend.value)}%
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default StatCard;
